import ApiService from "@/services/api";
import { EndpointKeys } from "@/config/api";
import type { EmployeesResponse, EmployeeFilters } from "@/types/api";

interface GetEmployeesOptions {
  filters?: EmployeeFilters;
  userId?: string; // superuser context
}

export async function getEmployees(
  options: GetEmployeesOptions = {},
): Promise<EmployeesResponse> {
  const { filters, userId } = options;

  const queryParams: Record<string, string | number> = {};

  if (filters) {
    if (filters.includeTerminated !== undefined) {
      queryParams["include_terminated"] = filters.includeTerminated
        ? "true"
        : "false";
    }
    if (filters.search) {
      queryParams["search"] = filters.search;
    }
  }

  if (userId && userId !== "current") {
    queryParams["userId"] = userId;
  }

  return ApiService.request<EmployeesResponse>(EndpointKeys.GET_EMPLOYEES, {
    queryParams,
  });
}

export async function getActiveEmployees(
  userId?: string,
): Promise<EmployeesResponse> {
  return getEmployees({ filters: { includeTerminated: false }, userId });
}


